var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Customers',"subtitle":_vm.name,"section":'Edit Profile'}}),_c('customer-individual-form',{attrs:{"action":"edit","loading":_vm.loading,"customer":_vm.customer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }